import { render, staticRenderFns } from "./serviceHome.vue?vue&type=template&id=0c4531f7&scoped=true"
import script from "./serviceHome.vue?vue&type=script&lang=js"
export * from "./serviceHome.vue?vue&type=script&lang=js"
import style0 from "./serviceHome.vue?vue&type=style&index=0&id=0c4531f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4531f7",
  null
  
)

export default component.exports